import script from "./GroupMsgItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./GroupMsgItem.vue?vue&type=script&setup=true&lang=ts"

import "./GroupMsgItem.vue?vue&type=style&index=0&id=83e9cd3e&scoped=true&lang=less"

import exportComponent from "/Users/neal/www/bonwey/qingtv-back-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-83e9cd3e"]])

export default __exports__